<div [class.ie]="isIE" [class.ios-safari]="isIOSSafari" [class.ms-edge]="isMicrosoftEdge" class="zoom-slider-container">
    <div class="zoom-slider">
        <button (click)="zoomIn($event)" aria-label="Die Seite vergrößern" class="zoom-plus">
            <i aria-hidden="true" class="fa fa-plus"></i>
        </button>

        <div [ngStyle]="{'background-image': 'url(' + assetService.getUrl('rectangle.png') + ')'}" class="zoom-range">
            <input #zoomValue (change)="changeZoomForIE(zoomValue.value, $event)"
                   (input)="changeZoom(zoomValue.value, $event)"
                   (keydown)="onKeyDown($event)"
                   (touchmove)="onTap($event)"
                   (touchstart)="onTap($event)"
                   [attr.max]="maxValue"
                   [attr.min]="minValue"
                   [attr.value]="currentZoomLevel"
                   aria-label="Zoomwert"
                   type="range"
                   tabindex="-1"
            />
        </div>

        <button (click)="zoomOut($event)" aria-label="Die Seite verkleinern" class="zoom-minus">
            <i aria-hidden="true" class="fa fa-minus"></i>
        </button>
    </div>
</div>

